export default __webpack_public_path__ + "static/media/legs_1_male.aebfd8eb.png";